<script>
import PortalService from "@/api-services/portal.service";

export default {
  name: "employeeCommitment",
  components: {},
  props: ["employeeMatricule"],
  data: function () {
    return {
      employeeCommitments: [],
      selectedCommitment: null,
      headers: [
        {
          text: "Engagement",
          value: "commitmentName",
          align: "center",
          width: 170,
          sortable: false,
        },
        {
          text: "Description",
          value: "commitmentSignatures[0].description",
          align: "center",
          sortable: false,
        },
        {
          text: "Signé le",
          align: "center",
          value: "signatureTime",
          groupable: false,
          sortable: false,
        },

        {
          text: "Statut",
          value: "isValid",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    getEmployeeCommitments: async function () {
      this.tableLoading = true;
      PortalService.getEmployeeCommitments(this.employeeMatricule)
        .then((response) => {
          this.employeeCommitments = response.data.requestResult;
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.status == 401) {
              this.$store.commit("setJwt", null);
              this.$store.commit("setIsAuthentified", false);
              this.$router.push("/");
            } else {
              this.$store.commit(
                "setNewErrorMessage",
                error.response.data.requestResult
              );
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$store.commit("setNewErrorMessage", error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$store.commit(
              "setNewErrorMessage",
              error.response.data.requestResult
            );
          }
          console.log(error.response.data);
        });
    },
  },
  computed: {},
  created() {
    if (this.$store.state.isAuthentified) {
      this.getEmployeeCommitments();
    }
  },
};
</script>

<template>
  <div id="employeeCommitment">
    <v-card flat>
      <v-card-text class="text-button font-weight-black pb-0 text-center"
        >Engagements
        <v-divider />
        <!-- <v-btn icon plain dark tile @click="newRemoteAccess()">
            <v-icon small color="grey darken-1">mdi-plus</v-icon>
          </v-btn> -->
      </v-card-text>

      <v-data-table
        dense
        :headers="headers"
        :items="employeeCommitments"
        item-key="accountId"
        group-by="domainName"
        class="elevation-1"
        disable-pagination
        hide-default-footer
      >
        <!-- eslint-disable-next-line -->
        <template v-slot:group.header="{ items, isOpen, toggle }">
          <th
            colspan="5"
            class="indigo darker-2 text-overline"
            style="color: white"
          >
            <v-icon small @click="toggle" dark
              >{{ isOpen ? "mdi-minus" : "mdi-plus" }}
            </v-icon>
            {{ items[0].domainName }}
          </th>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.signatureTime="{ item }">
          <span>{{ new Date(item.signatureTime).toLocaleString() }}</span>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.isValid="{ item }">
          <v-chip
            color="success"
            small
            label
            class="ml-1"
            v-if="item.isValid == true"
          >
            Signé
          </v-chip>
          <v-chip label color="error" small class="ml-1" v-else>
            À signé
          </v-chip>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.remoteAccessUserGroup_right="{ item }">
          <v-checkbox
            hide-details="true"
            dense
            false-value="deny"
            true-value="allow"
            v-model="item.remoteAccessUserGroup_right"
          ></v-checkbox>
        </template>
      </v-data-table>

      <!-- <v-list dense class="overflow-y-auto">
        <v-list-item-content
          color="primary"
          v-model="selectedRemoteAccessIndex"
        >
          <v-list-item
            v-for="commitment in employeeCommitments"
            :key="commitment.commitmentId"
          >
            <v-list-item-content>
              <v-list-item-title>{{
                commitment.commitmentName
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-row>
                <v-btn icon plain dark tile v-if="commitment.isValid">
                  <v-icon color="grey darken-1">mdi-lastpass</v-icon>
                </v-btn>
              </v-row>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-content>
      </v-list> -->
    </v-card>
  </div>
</template>
